import React from "react";
import {
  AppBar,
  Toolbar,
  Box
} from "@mui/material";
import { Link, useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import imgurl from "../assests/images/imgurl";

const WebHeader = () => {
  const gotTo = () => {
    let url = "https://aloxa.ai";
    window.open(url, "_blank");
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
    <AppBar
      position="static"
      sx={{ backgroundColor: 'transparent', boxShadow: 'none', padding: '0 20px' }}
    >
      <Toolbar className="webHeadertoolbar">

        <Box sx={{ display: 'flex', alignItems: 'center', gap: '30px' }} className="webHeaderBox">
          <a href="https://alopexia.com/" className="linkingIconHeader">
            <img src={imgurl.hairlossaiLogo} alt="New Logo" className="headerLogo mainlogo"/>
          </a>

          <Box sx={{ display: 'flex', gap: '45px' }} className="webappNavbarlinks">
            <a href="https://alopexia.com/" className="navItem active" rel="noopener noreferrer">Home</a>
            {/* <a href="https://alopexia.com/pages/about-alopexia" className="navItem">About Alopexia</a> */}
            {/* <a href="https://alopexia.com/for-men" className="navItem">For Men</a>
            <a href="https://alopexia.com/for-women" className="navItem">For Women</a> */}
            {/* <a href="https://alopexia.com/our-team" className="navItem">Our Team</a> */}
            {/* <Link to="/feedback" state={{from: "webheader"}} className="navItem">Feedback</Link> */}
          </Box>

        </Box>
      </Toolbar>
    </AppBar>
  </Box>
  );
};

export default WebHeader;
